export default {
	common: {
		retry: 'Reintentar',
		retry_access: 'Reintentar acceso',
		see_more: 'Ver más',
		system_default_device: 'Predeterminado del sistema',
		problem_occurred: 'Ha ocurrido un problema al intentar conectar en la videoconsulta. Se le redirigirá a la sala de espera de nuevo.',
		insurance: 'Aseguradora'
	},
	datetime: {
		locale: 'es',
		datetime_format: 'DD/MM/YYYY · HH:mm',
	},
	config: {
		microphone: 'Micrófono',
		external_headphones: 'Auriculares externos',
		camera: 'Cámara',
		how_to_permissions: '¿Cómo activar los permisos?',
		mic_and_vid_not_granted: 'Tu micrófono y cámara están desactivados',
		permissions_text: 'Para que los otros participantes puedan escucharte y verte, el navegador desde el que quieres unirte a la videoconsulta solicitará el <strong>acceso a tu micrófono y cámara</strong>. <p>Por último, debes terminar de <strong>establecer las preferencias del sistema</strong> para poder continuar.</p>',
	},
	waiting_room: {
		next_videoconsultation: 'Próxima videoconsulta',
		videoconsultation: 'Videoconsulta',
		title: 'Estás a punto de unirte a una videoconsulta',
		info: 'Información',
		access: 'Acceder',
		professional_not_available: {
			title: 'ESTAMOS ESPERANDO AL PROFESIONAL',
			message: 'Tu médico aún no se ha conectado. A veces pueden surgir pequeños retrasos. Gracias por tu paciencia.'
		},
		professional_no_show: {
			title: 'EL PROFESIONAL NO SE HA PRESENTADO',
			message: 'El profesional médico ha tenido algún inconveniente y parece que no va a poder unirse a la consulta. Te pedimos disculpas y te recomendamos agendar una nueva cita.'
		},
		capabilities_ko: {
			title: 'CLIENTE NO COMPATIBLE',
			message: 'Su navegador o dispositivo no son compatibles con la videoconsulta. Por favor, actualiza tu navegador o cambia el dispositivo de conexión.'
		},
	},
	participant_info: {
		professional: 'Profesional',
		patient: 'Paciente',
		subject: 'Motivo',
		subject_long: 'Motivo de la consulta',
		speciality: 'Especialidad',
		datetime: 'Fecha y hora',
		duration: 'Duración estimada',
		copy_link: 'Copiar enlace',
	},
	tools: {
		chat: 'Chat privado',
	},
	chat: {
		empty_title: '¿Quieres iniciar el chat privado?',
		empty_description:
			'Solo los participantes en esta videoconsulta tendrán acceso a los mensajes enviados.',
		type: 'Escribe tu mensaje...',
	},
	hang_up: {
		title: 'Finalizar videoconsulta',
		finish: 'Finalizar',
		suspend: 'Poner en espera',
		warning:
			'Para que esta videoconsulta se considere apta, es necesario que alcance los tres minutos de duración.',
		message: 'Este enlace de acceso es para un solo uso. Si <strong>finalizas</strong> esta videoconsulta, no podrás volver a acceder, incluso estando dentro del horario establecido.',
	},
	too_early: {
		title: 'ACCESO A LA VIDEOCONSULTA',
		vc_time: 'Hora de la videoconsulta',
		waiting_time: 'Tiempo de espera',
		message: 'Todavía es pronto para unirte. Vuelve a intentarlo en unos minutos: en caso de que tu médico llegue también con antelación, podrá darte acceso antes de la hora prevista. <br/> (se combinará con la hora dinámica, p.ej. "Lunes 15:20")',
		professional_available: 'Tu médico está disponible, ya puedes acceder a tu videoconsulta.',
	},
	permissions: {
		title: 'Activa cámara y micrófono',
		content: 'Para iniciar tu videoconsulta necesitamos acceder a tu cámara y micrófono.',
		request_permissions: 'Permitir acceso',
	},
	vc: {
		finish_title: 'Fin de la videoconsulta',
		finish_content:
			'La videoconsulta ha finalizado con éxito. ¡Gracias por utilizar nuestra plataforma!',
	},
	feedback: {
		title: '¿CÓMO VALORAS TU VIDEOCONSULTA?',
		success_by_video: 'Con éxito por vídeo',
		success_by_phone: 'Con éxito por teléfono',
		unsuccess: 'Sin éxito',
		reason: 'Indica el motivo:',
		patient_not_shown_up: 'Paciente no presentado',
		patient_could_not_connect: 'El paciente no pudo conectarse',
		other: 'Otro',
		fail_message: 'No se ha podido enviar el feedback. Por favor, inténtalo de nuevo.',
		already_registered_message: 'Esta videoconsulta ya ha sido valorada. No es posible valorarla nuevamente.',
	},
	meet_actions: {
		copy_link: 'Copiar enlace',
		share_screen: 'Compartir pantalla',
		stop_share_screen: 'Dejar de compartir',
	},
	alerts: {
		copied_link: 'Enlace de acceso a la videconsulta copiado.',
		participant_disabled_cam: 'ha desactivado su cámara.',
		participant_disabled_mic: 'ha desactivado su micrófono.',
		sharing_screen: 'Estás compartiendo pantalla',
		presentation: 'Presentación de',
	},
	errors: {
		title: 'Información sobre tu videoconsulta',
		invalid_code:
			'No se puede acceder a la videoconsulta. Esto puede deberse a que el enlace no es válido, no existe o aún no es la hora agendada.',
		title_too_early: 'Sala de espera',
		too_early: '¡Llegas pronto! Inténtalo de nuevo en unos minutos.',
		title_finished_meet: 'Videoconsulta no disponible',
		finished_meet: 'La hora de tu videoconsulta ya ha finalizado. Este link ha expirado',
		title_too_late: 'Videoconsulta finalizada',
		too_late: 'Esta videoconsulta ya ha finalizado.',
		refresh_meet_failed: 'Ha habido un error al cargar los datos de la videoconsulta. Por favor, inténtalo de nuevo.',
		devices_in_use_title: 'Dispositivos en uso',
		devices_in_use_description: 'No puedes acceder a la videoconsulta porque hay un problema de acceso a tu micrófono y cámara. Por favor, revisa que no los esté usando otra aplicación y otorga los permisos cuando te lo pida el navegador.',
		devices_not_found: 'Dispositivos no encontrados',
		devices_denied: 'Permisos denegados a los dispositivos',
		devices_error: 'Error al usar el micrófono/cámara'
	},
};
